<template>
  <div>
    Modals Page
  </div>
</template>

<script>
export default {
  name: 'Modals',
  created () {

  }
}
</script>



// WEBPACK FOOTER //
// Modals.vue?2d2d615f